import { network } from 'services/network';

import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

import { BreakPointMap, Widget } from 'components/Dashboards/Reporting/reporting.types';

export const getReport = (params: Params) => {
    return network.post<Report>('api/bo/reporting/getReport', params).then((response) => response.data);
};

interface Params {
    id: number;
}

export interface Report {
    components: Widget[];
    id: number;
    lastUpdateDate: number;
    lastUpdateUser: User;
    name: string;
    gridLayout: BreakPointMap;
    tags: Tag[];
    isTemplate: boolean | null;
    description: string | null;
    isMyFavorite: boolean;
}

export interface User {
    username: string;
    firstName: string | null;
    lastName: string | null;
    email: string;
    image: string; // URL or empty string
}
